import type {LocalDate} from '../domain/local-date.value-object';
import type {MealId} from '../domain/meal-id.value-object';

export const keys = {
  dailyDashboard: (date: LocalDate | null) => ['dashboard', 'daily', {date}] as const,
  dailyAll: () => ['dashboard', 'daily'] as const,
  mealDetail: (mealId: MealId) => ['dashboard', 'mealDetail', {mealId}] as const,
  mutations: {
    deleteMeal: () => ['dashboard', 'mutations', 'deleteMeal'] as const,
    editMeal: () => ['dashboard', 'mutations', 'editMeal'] as const,
    createManualMeal: () => ['dashboard', 'mutations', 'createManualMeal'] as const,
    copyMeal: () => ['dashboard', 'mutations', 'copyMeal'] as const,
    copyDay: () => ['dashboard', 'mutations', 'copyDay'] as const,
  },
} as const;
